import { Injectable } from '@angular/core';
import { RecentSearchItem } from './recent-search-item';
import { Const } from 'src/app/const';
import { BehaviorSubject } from 'rxjs';
import { AssetApiService } from 'src/app/api/asset/assetApiService';

@Injectable({
  providedIn: 'root'
})
export class RecentSearchesService {
  private recentSearches: RecentSearchItem[];
  public recentSearchesObservable: BehaviorSubject<RecentSearchItem[]>;

  saveRecentSearch(searchTerm: string, assetId: string): void {
    const existingItemIndex = this.recentSearches.findIndex(item => item.searchTerm == searchTerm);
    if (this.recentSearches.findIndex(item => item.searchTerm == searchTerm) >= 0)
      this.recentSearches.splice(existingItemIndex, 1);

    this.assetApiService.getAsset(assetId).subscribe(assets => {
      let recentSearchItem = new RecentSearchItem(searchTerm, assets[0]?.deviceType);
      this.recentSearches.unshift(recentSearchItem);
      if (this.recentSearches.length > Const.RECENT_SEARCHES_MAX) {
        this.recentSearches.splice(Const.RECENT_SEARCHES_MAX);
      }

      localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
    });
  }

  private loadRecentSearches(): RecentSearchItem[] {
    let recentSearches = localStorage.getItem('recentSearches');
    if (recentSearches)
      return JSON.parse(recentSearches);

    return [];
  }

  constructor(private assetApiService: AssetApiService) {
    this.recentSearches = this.loadRecentSearches();
    this.recentSearchesObservable = new BehaviorSubject<RecentSearchItem[]>(this.recentSearches);
  }
}
